import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FiAlignLeft,
  FiX,
  FiShoppingBag,
  FiUser,
  FiHome,
  FiHeart,
  FiSearch,
  FiGrid,
  FiPackage,
} from "react-icons/fi";
import { VscSignIn } from "react-icons/vsc";
import { LuPackageOpen } from "react-icons/lu";
import { MdOutlinePhone } from "react-icons/md";
import logo from "../../images/logo1.png";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { FaHeart } from "react-icons/fa";

const Navbar = ({ onCategoryClick, onContactClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [token, setToken] = useState("");
  const [role, setRole] = useState("");
  const [userId, setUserId] = useState();
  const [totalCartItem, setTotalCartItem] = useState(0);
  const [totalWishlistItem, setTotalWishlistItem] = useState(0);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 1) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("STITCHD_ID");
    if (token) {
      setToken(token);
      const decoded = jwtDecode(token);
      setRole(decoded.role);
      setUserId(decoded._id);
    }
  }, []);

  useEffect(() => {
    const fetchCartItems = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/user/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.user.cart) {
          let qyn = 0;
          response.data.user.cart.forEach((item) => {
            qyn += item.quantity;
          });
          setTotalCartItem(qyn);
        }
        if (response.data.user.wishlist) {
          setTotalWishlistItem(response.data.user.wishlist.length);
        }
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };

    if (userId) {
      fetchCartItems();
    }
  }, [userId]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleSignout = () => {
    localStorage.removeItem("STITCHD_ID");
    window.location.reload();
  };

  return (
    <nav
      className={`fixed w-full z-50 transition duration-300 ease-in-out ${
        isScrolled ? "bg-[#ebeaf0] shadow-2xl" : "bg-[#ebeaf0] border-b"
      }`}
    >
      <div className="container mx-auto p-4 flex justify-between items-center">
        <div className="md:w-40 w-24">
          <button
            onClick={toggleSidebar}
            className="text-gray-800 focus:outline-none"
          >
            {isOpen ? <FiX size={24} /> : <FiAlignLeft size={32} />}
          </button>
        </div>
        <Link
          to="/"
          onClick={() => {
            window.scrollTo(0, 0);
          }}
          className="md:text-2xl text-xl font-bold text-gray-800"
        >
          <img
            src={logo}
            className="md:h-12 w-auto h-6"
          />
        </Link>
        <div className="flex md:space-x-4 space-x-3 relative">
          <Link
            to="/"
            className="text-gray-800 hover:text-red-600 flex items-center"
          >
            <FiSearch className="md:mr-1 text-2xl" />
          </Link>
          <Link
            to="/account"
            className="text-gray-800 hover:text-red-600 items-center hidden md:flex"
          >
            <FiUser className="mr-1 md:text-2xl" />
          </Link>

          <Link
            to="/wishlist"
            className="text-gray-800 hover:text-red-600 flex items-center"
          >
            {totalWishlistItem > 0 ? (
              <FaHeart className="absolute text-red-600 ml-[2.8px] text-[19px]" />
            ) : (
              ""
            )}
            <FiHeart className="md:mr-1 text-2xl" />
          </Link>
          <Link
            to="/cart"
            className="text-gray-800 hover:text-red-600 flex items-center relative"
          >
            <FiShoppingBag className="md:mr-1 text-2xl" />
            {totalCartItem > 0 && (
              <span className="absolute -top-1 -right-1 md:-right-0 bg-black text-white text-[11px] rounded-full w-[14px] h-[14px] flex items-center justify-center font-twentieth-century">
                {totalCartItem}
              </span>
            )}
          </Link>
        </div>
      </div>

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-[#ebeaf0] shadow-lg transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out z-40`}
      >
        <div className="p-4 flex justify-between items-center border-b">
          <span className="text-2xl font-bold text-gray-800 ml-4">
            <img src={logo} alt="logo" className="w-auto h-8 " />
          </span>
          <button
            onClick={toggleSidebar}
            className="text-gray-800 focus:outline-none"
          >
            <FiX size={24} />
          </button>
        </div>
        <div className="p-4 flex flex-col space-y-4 ml-4 text-lg">
          <Link
            to="/"
            className="text-gray-800 hover:text-red-600 flex items-center"
            onClick={() => {
              window.scrollTo(0, 0);
              toggleSidebar();
            }}
          >
            <FiHome className="mr-2" />
            Home
          </Link>

          <Link
            to="/allproduct/allproduct"
            className="text-gray-800 hover:text-red-600 flex items-center"
            onClick={toggleSidebar}
          >
            <FiPackage className="mr-2" />
            All Products
          </Link>
          <Link
            to="/"
            className="text-gray-800 hover:text-red-600 flex items-center"
            onClick={() => {
              toggleSidebar();
              onCategoryClick();
            }}
          >
            <FiGrid className="mr-2" />
            Shop by Category
          </Link>
          <Link
            to="/cart"
            className="text-gray-800 hover:text-red-600 flex items-center"
            onClick={toggleSidebar}
          >
            {totalCartItem > 0 && (
              <span className="absolute ml-2 mb-3 bg-black text-white text-[11px] rounded-full w-[14px] h-[14px] flex items-center justify-center font-twentieth-century">
                {totalCartItem}
              </span>
            )}
            <FiShoppingBag className="mr-2" />
            Bag
          </Link>
          {token && (
            <Link
              to="/orders"
              className="text-gray-800 hover:text-red-600 flex items-center"
              onClick={toggleSidebar}
            >
              <LuPackageOpen className="mr-2" />
              My Orders
            </Link>
          )}
          {token && role === "ADMIN" && (
            <Link
              to="/allorders"
              className="text-gray-800 hover:text-red-600 flex items-center"
              onClick={toggleSidebar}
            >
              <LuPackageOpen className="mr-2" />
              All Orders
            </Link>
          )}
          {token && (
            <Link
              to="/sidebar"
              className="text-gray-800 hover:text-red-600 flex items-center md:hidden"
              onClick={toggleSidebar}
            >
              <FiUser className="mr-2" />
              Account
            </Link>
          )}
          {!token && (
            <Link
              className="text-gray-800 hover:text-red-600 flex items-center"
              onClick={toggleSidebar}
              to="/signin"
            >
              <VscSignIn className="mr-2" />
              Sign In
            </Link>
          )}
          {token && (
            <Link
              className="text-gray-800 hover:text-red-600 flex items-center"
              onClick={handleSignout}
              to="/"
            >
              <VscSignIn className="mr-2" />
              Sign Out
            </Link>
          )}
          <Link
            className="text-gray-800 hover:text-red-600 flex items-center"
            onClick={() => {
              toggleSidebar();
              onContactClick();
            }}
          >
            <MdOutlinePhone className="mr-2" />
            Contact Us
          </Link>
        </div>
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-30"
          onClick={toggleSidebar}
        ></div>
      )}
    </nav>
  );
};

export default Navbar;
